import { useEffect, useState } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

export default function ComingSoonPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />

      {/* Hero Section */}
      <div className="relative pt-20 min-h-[70vh] bg-gradient-to-br from-[#144E5D] to-[#0f3a47] overflow-hidden flex items-center">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-20 right-20 w-[500px] h-[500px] bg-[#B8D8DE] rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#B8D8DE] rounded-full blur-2xl animate-pulse" style={{ animationDelay: "2s" }} />
        </div>

        <div className="max-w-3xl mx-auto px-6 py-12 text-center relative z-10">
          {/* Icon */}
          <div className="mb-6 animate-fade-in">
            <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto border-2 border-[#B8D8DE]/30 hover:bg-white hover:border-white transition-all duration-300 group">
              <i className="ri-time-line text-4xl text-[#B8D8DE] group-hover:text-[#144E5D] transition-colors duration-300"></i>
            </div>
          </div>

          {/* Main Content */}
          <div className="space-y-4 animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full mb-2">
              <i className="ri-box-3-line text-sm text-[#B8D8DE]"></i>
              <span className="text-xs text-[#B8D8DE] font-medium">Product Launching Soon</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              Coming Soon
            </h1>

            <p className="text-lg md:text-xl text-gray-200 max-w-xl mx-auto leading-relaxed">
              This product will be available for purchase soon. We're finalizing the details to bring you the best quality!
            </p>

            <p className="text-base text-[#B8D8DE] max-w-lg mx-auto">
              Check our Amazon store below. Have questions? We're here to help!
            </p>
          </div>

          {/* CTAs */}
          <div className="flex justify-center items-center mt-8 animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <a
              href="https://www.amazon.com/stores/CUREWELL/page/329507BC-B6E8-498D-BC51-7DEEF5B1D279?lp_asin=B0GYT5SK6P&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto"
              target="_blank"
              rel="noopener noreferrer"
              className="px-7 py-3 bg-white text-[#144E5D] font-semibold rounded-xl hover:bg-gray-200 hover:shadow-2xl hover:-translate-y-2 hover:ring-1 hover:ring-white/50 transition-all duration-300 inline-flex items-center gap-2 group"
            >
              <i className="ri-store-3-line text-lg group-hover:scale-110 transition-transform"></i>
              Check Out Our Store
            </a>
          </div>

          {/* Social Icons */}
          <div className="mt-12 animate-fade-in" style={{ animationDelay: "0.6s" }}>
            <p className="text-gray-300 mb-3 text-xs">Stay connected with us</p>
            <div className="flex justify-center gap-3">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#144E5D] hover:scale-110 transition-all duration-300 border border-white/20"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#144E5D] hover:scale-110 transition-all duration-300 border border-white/20"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#144E5D] hover:scale-110 transition-all duration-300 border border-white/20"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Wave */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
      </div>

      {/* Features Section */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-8">
          Why Wait for This Product?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-6 rounded-2xl bg-gray-50 hover:bg-[#144E5D]/5 transition-all duration-300 group">
            <div className="w-14 h-14 bg-[#144E5D]/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-[#144E5D] transition-all duration-300">
              <i className="ri-star-line text-2xl text-[#144E5D] group-hover:text-white transition-all duration-300"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Premium Quality</h3>
            <p className="text-sm text-gray-600">
              We're ensuring this product meets our highest standards before launch
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl bg-gray-50 hover:bg-[#144E5D]/5 transition-all duration-300 group">
            <div className="w-14 h-14 bg-[#144E5D]/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-[#144E5D] transition-all duration-300">
              <i className="ri-price-tag-3-line text-2xl text-[#144E5D] group-hover:text-white transition-all duration-300"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Best Value</h3>
            <p className="text-sm text-gray-600">
              Worth the wait - competitive pricing for premium quality
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl bg-gray-50 hover:bg-[#144E5D]/5 transition-all duration-300 group">
            <div className="w-14 h-14 bg-[#144E5D]/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-[#144E5D] transition-all duration-300">
              <i className="ri-shield-check-line text-2xl text-[#144E5D] group-hover:text-white transition-all duration-300"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Trusted Brand</h3>
            <p className="text-sm text-gray-600">
              All Curewell products are backed by our quality guarantee
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
